import { MouldingType } from "src/app/core/enums/moulding-type.enum";
import cuttingInstructions from "./cutting-instructions";
import allowances from "./allowances";

export default [
  {
    id: 1, name: "Frame",
    mouldingType: MouldingType.Frame,
    instruction: {
      id: 2,
      name: "Allowance",
      list: allowances
    },
    measurement: [
      { id: 1, name: "Width", prefix: "W", value: 1 },
      //{ name: "Height", prefix: "H", value: 1 },
      { id: 3, name: "Length", prefix: "L", value: 1 }
    ],
    liner: {
      value: false
    },
  },
  {
    id: 2, name: "Chop",
    mouldingType: MouldingType.Chop,
    instruction: {
      id: 2,
      name: "Allowance",
      list: allowances
    },
    measurement: [
      { id: 1, name: "Width", prefix: "W", value: 1 },
      { id: 3, name: "Length", prefix: "L", value: 1 }
    ],
    liner: {
      value: false
    },
  },
  {
    id: 3, name: "Length",
    mouldingType: MouldingType.Length,
    instruction: {
      id: 1,
      name: "Cutting Instruction",
      list: cuttingInstructions
    },
    measurement: [
      //{ name: "Length", prefix: "L", value: 1 }
    ]
  },
  {
    id: 5, name: "Rail",
    mouldingType: MouldingType.Rail,
    instruction: {
      id: 2,
      name: "Allowance",
      list: allowances
    },
    measurement: [
      { id: 3, name: "Length", prefix: "L", value: 1 }
    ]
  },
]
